import gql from 'graphql-tag';

const RETURN_EXCEPTION_ORDER_FIELDS = gql`
  fragment ReturnExceptionOrderFields on ReturnExceptionOrder {
    orderId
    items {
      orderItemId
      title
      availableQuantity
      blockers
      unavailable
    }
    exceptions {
      id
      orderId
      storeId
      items {
        orderItemId
        quantity
      }
      overrideCodes
      reason
      expiresAt
      createdAt
      revokedAt
      consumedAt
      consumedReturnId
      stale
    }
  }
`;

export const GET_RETURN_EXCEPTION_ORDER = gql`
  query ReturnExceptionOrder($storeId: String!, $orderId: String!) {
    returnExceptionOrder(storeId: $storeId, orderId: $orderId) {
      ...ReturnExceptionOrderFields
    }
  }
  ${RETURN_EXCEPTION_ORDER_FIELDS}
`;

export const GRANT_RETURN_EXCEPTION = gql`
  mutation GrantReturnException($input: GrantReturnExceptionInput!) {
    grantReturnException(input: $input) {
      ...ReturnExceptionOrderFields
    }
  }
  ${RETURN_EXCEPTION_ORDER_FIELDS}
`;

export const REVOKE_RETURN_EXCEPTION = gql`
  mutation RevokeReturnException(
    $storeId: String!
    $orderId: String!
    $exceptionId: String!
  ) {
    revokeReturnException(
      storeId: $storeId
      orderId: $orderId
      exceptionId: $exceptionId
    ) {
      ...ReturnExceptionOrderFields
    }
  }
  ${RETURN_EXCEPTION_ORDER_FIELDS}
`;
